export class BlobUtilities {

    public static openBlobInAnotherTab(pdfBlob: Blob): void {
        const blobUrl = URL.createObjectURL(pdfBlob);
        const newWindow = window.open(blobUrl, '_blank');

        if (!newWindow) {
            // If pop-ups are blocked, provide a manual download
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'invoice.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        // Clean up after a while to avoid memory leaks
        setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/blob/blob-utils.ts